import { render, staticRenderFns } from "./geoData.vue?vue&type=template&id=d079a864&"
import script from "./geoData.vue?vue&type=script&lang=js&"
export * from "./geoData.vue?vue&type=script&lang=js&"
import style0 from "./geoData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports